import { DEFAULT_PRODUCT_FEATURES } from '@bounty/constants'

export const fallbackTo = (
  value: string | undefined | null,
  fallback: string,
) => {
  if (!value || !String.prototype.trim.call(value)) {
    return fallback
  }
  return value
}

export const constructFeaturesOrFallback = (
  features?: readonly string[] | null,
) => {
  if (!features) {
    return DEFAULT_PRODUCT_FEATURES
  }

  return features.filter((f) => f.trim() !== '')
}
